(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-waiting.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-waiting.js');

'use strict';

const {
  logger
} = svs.playerLoginReact;
const {
  ReactButton: Button
} = svs.ui;
const {
  useHistory
} = ReactRouterDOM;
const {
  Loader
} = svs.components.ReactLoader;
const QRCode = svs.components.libs.ReactQRCode;
const {
  frejaeIdProgressStatus,
  appWaitStatus,
  route
} = svs.playerLoginReact.constants;
const useFrejaeIdPollStatus = svs.playerLoginReact.frejaeid.useFrejaeIdPollStatus;
const {
  frejaeIdBackendStatus
} = svs.playerLoginReact.store.playerloginreactactions;
const {
  useUrlHelper,
  LoginQrCode
} = svs.playerLoginReact.sharedComponents;

const FrejaeIdWaiting = _ref => {
  let {
    isLogin = true,
    frejaeIdPollWait = appWaitStatus.WAITING_QRCODE
  } = _ref;
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const frejaeIdAuthRef = ReactRedux.useSelector(state => state.playerloginreact.authRef);
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const {
    appUrl,
    qrCode,
    backendStatus,
    cancelBackendPoll
  } = useFrejaeIdPollStatus(isLogin, frejaeIdAuthRef);
  const [waitStatus, setWaitStatus] = React.useState(frejaeIdProgressStatus.BEFORE_POLL);
  const {
    navigateToCancelUrl
  } = useUrlHelper();
  const [isOtherDeviceLoginClicked, setIsOtherDeviceLoginClicked] = React.useState(false);
  logger.debug('**** app url', appUrl);

  React.useEffect(() => {
    dispatch(frejaeIdBackendStatus(backendStatus));
    setWaitStatus(backendStatus);
  }, [backendStatus]);
  React.useEffect(() => {
    logger.debug('appurl:', appUrl);
    if (appUrl && appUrl.length > 5 && frejaeIdPollWait === appWaitStatus.WAITING_APP) {
      logger.debug('**** open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  }, [appUrl]);
  const onCancelClick = async () => {
    await cancelBackendPoll();
    if (isStandardMobile) {
      const loginPath = baseUrl;
      logger.debug("**** Doing hard load of ".concat(isLogin ? 'login' : 'registrate'));
      if (isLogin) {
        svs.utils.url.navigate(loginPath + route.LOGIN_FREJAEID_START_ROUTE);
      } else {
        svs.utils.url.navigate(loginPath + route.REGISTRATE_FREJAEID_ROUTE);
      }
    } else if (frejaeIdPollWait === appWaitStatus.WAITING_QRCODE) {
      navigateToCancelUrl();
    } else if (isLogin) {
      history.push(route.LOGIN_FREJAEID_START_ROUTE);
    } else {
      history.push(route.REGISTRATE_FREJAEID_ROUTE);
    }
  };
  const handleLoginOnOtherDevice = () => {
    setIsOtherDeviceLoginClicked(true);
  };
  logger.debug('frejaeidwaitstatus', waitStatus);
  logger.debug('frejaeidpollwait', frejaeIdPollWait);
  return React.createElement("div", {
    className: "fc-navy"
  }, (waitStatus === frejaeIdProgressStatus.BEFORE_POLL || waitStatus === frejaeIdProgressStatus.WAITING_APP) && frejaeIdPollWait === appWaitStatus.WAITING_APP && (!isOtherDeviceLoginClicked ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-4 margin-top-3 margin-bottom-1"
  }, React.createElement("p", null, "F\xF6rs\xF6ker starta Freja eID-appen")), isStandardMobile && React.createElement("div", null, React.createElement(Button, {
    block: true,
    onClick: handleLoginOnOtherDevice,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 en annan enhet"))) : React.createElement("div", {
    className: "margin-bottom-2 margin-top-4"
  }, React.createElement("div", {
    className: "login-react-qrcode"
  }, qrCode && React.createElement(QRCode, {
    className: "margin-top",
    size: 120,
    value: qrCode
  })))), (waitStatus === frejaeIdProgressStatus.BEFORE_POLL || waitStatus === frejaeIdProgressStatus.SHOWING_QRCODE || waitStatus === frejaeIdProgressStatus.ERROR_POLL || waitStatus === frejaeIdProgressStatus.CLIENT_TIMEOUT) && frejaeIdPollWait === appWaitStatus.WAITING_QRCODE && React.createElement(LoginQrCode, {
    qrCode: qrCode
  }, "Skanna QR-koden med Freja eID-appen"), (waitStatus === frejaeIdProgressStatus.SHOWING_SPINNER || waitStatus === frejaeIdProgressStatus.NEW_CUSTOMER || waitStatus === frejaeIdProgressStatus.RETAIL_CUSTOMER || waitStatus === frejaeIdProgressStatus.REACTIVATED_CUSTOMER || waitStatus === frejaeIdProgressStatus.ONLINE_CUSTOMER) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-8"
  }, waitStatus === frejaeIdProgressStatus.SHOWING_SPINNER ? 'Väntar på identifiering i app' : 'Loggar in...'), React.createElement("div", {
    className: "login-react-margin-top-7 login-react-loader-view-container"
  }, React.createElement(Loader, {
    size: 300
  }))), React.createElement("div", {
    className: "margin-xs-top-1 margin-md-top-2"
  }, React.createElement(Button, {
    block: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLoginReact.frejaeid.components.FrejaeIdWaiting = FrejaeIdWaiting;

 })(window);